import React, { Component } from "react";
import * as Sentry from "@sentry/react";
import styled from "styled-components";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

library.add(faExclamationTriangle);

class ErrorBoundary extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { hasError: props?.hasError || false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    console.log("componentDidCatch", error);
    Sentry.captureException(error);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <Wrapper>
          <Content>
            <Icon>
              <FontAwesomeIcon icon={faExclamationTriangle} />
            </Icon>
            <Title>Something went wrong...</Title>
          </Content>
        </Wrapper>
      );
    }

    return children;
  }
}

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
};

export const Wrapper = styled.div`
  padding-top: 70px;
  margin-left: 60px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mediaMaxWidth.tablet`
    margin-left: 0;
  `}
`;

export const Content = styled.div`
  background-color: #673490;
  color: #fff;
  padding: 30px 0;
  border-radius: 8px;
  width: 100%;
  max-width: 600px;
  margin-top: 50px;

  ${mediaMaxWidth.tablet`
    max-width: calc(100vw - 20px);
    padding: 20px 0;
  `}
`;

export const Icon = styled.div`
  font-size: 3em;

  ${mediaMaxWidth.tablet`
    font-size: 2em;
  `}
`;

export const Title = styled.div`
  font-size: 1.4em;

  ${mediaMaxWidth.tablet`
    font-size: 1em;
  `}
`;

export default ErrorBoundary;
